export class ArrayUtil {

  static arraysSaoIguais(arr1: any[], arr2: any[]): boolean {
    const containsAll = (arr1, arr2) => {
      return arr2.every(arr2Item => arr1.includes(arr2Item));
    }

    const sameMembers = (arr1, arr2) => {
        return containsAll(arr1, arr2) && containsAll(arr2, arr1);
    }

    return sameMembers(arr1, arr2);
  }

  static removerObjetoDoArray(arr: any[], item: any): any[] {
    arr
      .forEach( (o, index) => {
        if ( o === item ) {
          arr.splice(index, 1);
        }
      });

    return arr;
  }

  static clonarArrayComObjetos(arrOrigem: any[], arrDestino: any[]): any[] {
    arrOrigem.forEach(o => {
      arrDestino.push(Object.assign({}, o))
    });

    return arrDestino;
  }

  static quantidadeDeNiveisDoArray(a: []): number {
    const f = a =>
      a[0] ?                   // if a is an array
      Math.max(...a.map(f))    // return the maximum depth of each element in the array
        +1                     // add 1 to increase the depth
      :0;
      return f(a);
  }

}
